// extracted by mini-css-extract-plugin
export var bold = "_xf-0";